// extracted by mini-css-extract-plugin
module.exports = {"formInput":"styles--formInput--3APiE","bgFileInput":"styles--bgFileInput--bvbgi","avatarSize":"styles--avatarSize--3nn_1"};